import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { messages } from '../constants/messages';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 sm:py-24 px-4 sm:px-10 bg-gray-50">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-[#EF5D22] font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4 block">{messages.faq.badge}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4 sm:mb-6 text-gray-900">
            {messages.faq.titlePart1} <span className="text-[#EF5D22]">{messages.faq.titlePart2}</span>
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {messages.faq.questions.map((item, idx) => (
            <div key={idx} className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <button 
                className="w-full px-4 sm:px-8 py-4 sm:py-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors gap-4"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-base sm:text-xl font-bold text-gray-900">{item.question}</span>
                <ChevronDownIcon 
                  className={`w-5 h-5 sm:w-6 sm:h-6 text-[#EF5D22] transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              {openIndex === idx && (
                <div className="px-4 sm:px-8 pb-4 sm:pb-6 text-gray-600 text-sm sm:text-lg leading-relaxed animate-fadeIn">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 p-6 sm:p-10 bg-[#0066CC] rounded-2xl sm:rounded-[2rem] text-center text-white shadow-xl relative overflow-hidden">
          <div className="relative z-10">
            <h3 className="text-xl sm:text-3xl font-bold mb-3 sm:mb-4">{messages.faq.footerTitle}</h3>
            <p className="text-white/80 mb-6 sm:mb-8 text-sm sm:text-lg">{messages.faq.footerSubtitle}</p>
            <button className="bg-[#EF5D22] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg hover:bg-[#d9541a] transition-all transform hover:scale-105 shadow-lg">
              {messages.faq.footerCta}
            </button>
          </div>
          {/* Decorative circles */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
